import './front.css';
import React from 'react';
import leftarrow from './img/flèche CTA retour.svg'
import logo from './img/Logo assur bon plan.png'
import telephone from './img/icon telephone.svg'
import FrontLanding from './front/landing'
import FrontDetails1 from './front/details1';
import FrontDetails2 from './front/details2';
import FrontDetails3 from './front/details3';
import FrontVous from './front/vous';
import FrontVehicule from './front/vehicule';
import FrontVehiculeAuto from './front/vehiculeAuto';
import FrontAntecedents from './front/antecedents';
import FrontError from './front/error';
import FrontErrorUnauthorized from './front/errorUnauthorized';
import FrontSubscribeError from './front/subscribeError';
import FrontCancelled from './front/cancelled';
import FrontSubscribing from './front/subscribing';
import FrontReceive from './front/receive';
import FrontPayment from './front/payment';
import FrontPaidSubscribed from './front/paid_subscribed';
import FrontSubscribedSolly from './front/subscribed_solly';
import FrontPaidSubscribedFma from './front/paid_subscribed_fma';
import FrontSubscribeSolly from './front/subscribe_solly';
import DataDevis from './dataDevis'
import Footer from './front/footer';
import BlueHeader from './front/blueHeader'
import waiter from './img/wait.svg'
import api from './apiConnector'

const showAxa = process.env.REACT_APP_SHOW_AXA === 'true'
const envDev = process.env.REACT_APP_DEV === 'true'
const showFma = process.env.REACT_APP_SHOW_FMA === 'true'

const pageToBranch = {'details1':'xena','details2':'axa','details3':'fma'}

class Front extends React.Component {
    
    constructor(props) {
        super(props);
        const {page} = this.readHash()
        this.state = {
            devis: false,
            page: page,
            waiting: false,
            enableClientSubscription:false,
            preClosed:false,
            affiliateLogin:false,
            affiliate:{},
            sponsor:{},
            id:props.id || api.id,
            type:props.type || api.type,
            unauthorized:false,
            lastBranch:false,
            axaAlive:api.axaAlive
        }
        this.enableClientSubscription = false
        this.preClosed = false
        this.checkingStatus = false
        this.changingPage = false
        this.topRef = React.createRef()
        this.statusToPage = {
            'paid_subscribed':'paid_subscribed',
            'paid_subscribed2':'paid_subscribed2',
            'paid_subscribed3':'paid_subscribed3',
            'subscribed_solly':'subscribed_solly',
            'subscribing':'subscribing',
            'subscribing2':'subscribing2',
            'subscribing3':'subscribing3',
            'subscribe_error':'subscribe_error',
            'subscribe_error2':'subscribe_error2',
            'subscribe_error3':'subscribe_error3',
            'presubscribe_error':'subscribe_error',
            'cancelled':'cancelled'
        }
        if ( ! this.props.embeded ) {
            window.addEventListener("hashchange", this.onHashChange.bind(this), false);
        }
    }


    componentDidMount() {
        api.registerDevisView(this)
        api.registerEnableView(this)
        if ( this.state.id ) {
            api.post(
                {action:'get_devis',
                 id:this.state.type+this.state.id},
                ()=>{}
            )
        } else {
            console.log('Call to create_devis',this.state.type)
            api.post(
                {   action:'create_devis',
                    id:this.state.type,
                    affiliate:api.affiliate
                },
                (res)=>{
                    console.log('back from create_devis',res,res.devis)
                },
                (res)=>{}
            )
        }
    
    }

    componentWillUnmount() {
        api.unregisterDevisView(this)
        api.unregisterEnableView(this)
    }

    notifyUnauthorized() {
        this.setState({unauthorized:true})
    }

    setEnableClientSubscription(enabled) {
        this.enableClientSubscription = enabled
        this.setState({enableClientSubscription:enabled})
    }

    setAxaAlive(alive) {
        this.setState({axaAlive:alive})
    }


    setPreClose(closed) {
        this.preClosed = closed
        this.setState({preClosed:closed})
    }

    setPage(page,force=false) {
        const devis = this.state.devis
        if (( !force )&&( devis.status_process in this.statusToPage )) {
            page = this.statusToPage[devis.status_process]
        }
        if ( ['details1','details2','details3'].includes(page) ) this.setState({
            lastBranch: pageToBranch[page]
        })
        if ( this.props.embeded ) {
            this.setState({page:page})
            this.changingPage = true
        } else {
            window.location.hash='#'+page
        }
    }


    validatePayment() {
        if ( window.confirm('Attention ! La souscription va être lancée sans paiement. Êtes-vous sûr que le paiement a déjà été réalisé ou sera réalisé par un autre moyen ?') ) {
            api.post(
                {
                    action:'validate_payment',
                    id:this.state.type+this.state.id
                },
                ()=>{}
            )
        }
    }

    sendPaymentLink() {
        api.post(
            {
                action:'send_payment_link',
                id:this.state.type+this.state.id
            },
            ()=>{
                alert('L\'email est posté. Lorsque le client aura payé, les documents lui seront envoyés automatiquement.')
            }
        ) 
    }

    changeParams(params) {
        api.post(
            {
                action:'change_params',
                id:this.state.type+this.state.id,
                params:JSON.stringify(params),
                devis_timestamp:Date.now()
            },
            ()=>{}
        )
    }

    readHash() {
        let match = window.location.hash.match(/#(.*)$/)
        return {page:( match &&( match[1] !== undefined ) )? decodeURIComponent(match[1]) : '' }
    }

    onHashChange() {
        let {page} = this.readHash()
        const devis = this.state.devis
        if ( devis.status_process in this.statusToPage ) {
            page = this.statusToPage[devis.status_process]
        }
        if ( page != this.state.page ) {
            this.changingPage = true
            this.setState({page:page})
        }
    }

    receiveDevis(devis) {

        if ( this.props.embeded &&( devis._id.$oid != this.state.id )) return

        this.setState({id:devis._id.$oid,type:devis.type,devis:devis},()=>{

            const {devis} = this.state
            const {params,status_process,getting_documents} = devis
            const {periodicite,own_iban} = params

            if ( !(( periodicite == 'A' )||( periodicite == 'M' )) ) {
                this.changeParams({'periodicite':'M'})
            }
            if (( own_iban !== 'O' )&&( own_iban !== 'N' )) {
                this.changeParams({'own_iban':'O'})
            }

            if (( status_process == 'paid_unsubscribed' )&&( devis.validated > 0 ))  {
                devis.status_process = 'subscribing' // not triggering a rerender, just a safe-guard for following verifications ; will be officially set by server reply
                this.changingPage = true 
                api.post(
                    {
                        action:'subscribe',
                        id:this.state.type+this.state.id
                    },
                    ()=>{}
                )
            }

            if (( status_process == 'paid_unsubscribed2' )&&( this.state.axaAlive ))  {
                devis.status_process = 'subscribing2' // not triggering a rerender, just a safe-guard for following verifications ; will be officially set by server reply
                this.changingPage = true
                api.post(
                    {
                        action:'subscribe2',
                        id:this.state.type+this.state.id
                    },
                    ()=>{}
                )
            }

            if ( status_process == 'paid_unsubscribed3' )  {
                devis.status_process = 'subscribing3' // not triggering a rerender, just a safe-guard for following verifications ; will be officially set by server reply
                this.changingPage = true
                api.post(
                    {
                        action:'fma_subscribe',
                        id:this.state.type+this.state.id
                    },
                    ()=>{}
                )
            }

            if ( this.enableClientSubscription 
                &&( status_process == 'paid_subscribed' )
                &&(
                    ( getting_documents <= 0 )&&( getting_documents >= -1 )
            )) {
                devis.getting_documents = 1
                api.post(
                    {
                        action:'get_documents',
                        id:this.state.type+this.state.id
                    },
                    ()=>{}
                )
            }
    
            if ( ! this.state.page ) {
                if (( this.state.devis.status_process=='ongoing' )||( this.state.devis.status_process=='En cours' )) {
                    this.setState({page: ((this.state.devis.params.MER)||(this.state.devis.params.tarif_choisi==0)) ? 'landing' : 'vehicule' })
                } else {
                    this.setState({page: this.statusToPage[this.state.devis.status_process] })    
                }
            } else {
                if ( this.state.devis.status_process in this.statusToPage ) {
                    this.setState({page:this.statusToPage[this.state.devis.status_process]})
                }
            }
    
            if ( this.state.devis.affiliate &&( this.state.affiliateLogin != this.state.devis.affiliate ) ) {
                this.setState({affiliateLogin:this.state.devis.affiliate})
                api.post(
                    {action:'get_sponsor_contact',
                    login:this.state.devis.affiliate},
                    (res)=>{
                        this.setState({affiliate:res.contact,sponsor:res.sponsor})
                    }
                )
            }
    
            this.setState({waiting:false})

        })

    }

    componentDidUpdate(prevProps, prevState) {
        const pageToResync = {
            'landing':true
        }
        const {devis,waiting,page} = this.state

        if (
            ( !waiting )
            &&( ! devis.synchronized )
            &&( pageToResync[page] )
            &&( devis.status_process == 'ongoing' )
            &&( !this.preClosed )
        ) {
            this.setState({waiting:true})
            api.post(
                {
                    action:'get_devis',
                    resync:true, // This forces re-synchronization : calculates prices by contacting xenassur
                    id:this.state.type+this.state.id
                }
            )
        }

        
        if ( this.changingPage ) {
            if ( this.topRef.current ) {
                this.topRef.current.scrollIntoView({behavior:'instant'});
                this.changingPage = false
            }
        }
    }

    resync( full=false ) {
        api.post( {
                action:'get_devis',
                resync:true, // This forces re-synchronization : calculates prices by contacting xenassur
                id:this.state.type+this.state.id,
                full:full
            },
            ()=>{}
        )
    }

    restart() {

        const devis = this.state.devis
        if ( this.enableClientSubscription 
            && ( devis.status_process == 'presubscribe_error' )
        ) {
            devis.status_process = 'subscribing'
            devis.params.error = false
            this.changingPage = true
            api.post(
                {
                    action:'subscribe',
                    id:this.state.type+this.state.id
                },
                ()=>{}
            )
            this.setState({
                devis:devis,
                page: this.statusToPage[devis.status_process]
            })
        }

        if ( this.state.axaAlive 
            && ( devis.status_process == 'subscribe_error2' )
        ) {
            devis.status_process = 'subscribing2' // not triggering a rerender, just a safe-guard for following verifications ; will be officially set by server reply
            devis.params.error = false
            this.changingPage = true
            api.post(
                {
                    action:'subscribe2',
                    id:this.state.type+this.state.id
                },
                ()=>{}
            )
        }
    }
    
    checkStatus( ignoreFields ) {
        if ( !this.checkingStatus ) {
            this.checkingStatus = true
            let payload = {
                action:'get_devis',
                id:this.state.type+this.state.id
            }
            if ( ignoreFields ) {
                payload.ignore_fields = JSON.stringify(ignoreFields)
            } else {
                payload.ignore_status = this.state.devis.status_process
            }
            api.post(
                payload,
                ()=>{
                    this.checkingStatus = false
                }
            )
        }
    }

    ignoreTransaction() {
        if ( window.confirm('Attention, si le client est déjà sur la page de paiement et que vous ignorer cet ordre de paiement, il risque de payer un montant incorrect.') ) {

        }
    }

    validateDevis(what='xena') {
        const me = this
        switch ( what ) {
            case 'xena':
                if (( !this.preClosed )&& ( !this.state.devis.validated )&& this.state.devis.synchronized ) {

                    let devis = this.state.devis
                    devis.validated = -1
                    this.setState({devis:devis})

                    this.validatingDevis = true
                    api.post(
                        {
                            action:'validate_devis',
                            id:this.state.type+this.state.id,
                            devis_timestamp:Date.now()
                        },
                        (res)=>{
                            if ( res.devis.validated <= -2 ) {
                                // Force devis reception in case of failed validation
                                // This overrids the timestamp filter
                                const dataDevis = new DataDevis(res.devis)
                                me.receiveDevis(dataDevis)
                            }
                        }
                    )
                }
            break;
            case 'axa':
                // TODO : validate axa operationnal and devis ok
            break;
        }
    }

    getComponent() {
        
        const devis = this.state.devis
        const typeAuto = this.state.type == 'auto'

        const waiting = ( this.state.waiting ||( ! devis ) )&&( !this.state.unauthorized )
        if ( waiting ) return ''

        if ( this.state.unauthorized ) {
            return FrontErrorUnauthorized
        }

        if (( devis.params.error||(devis.validated==-2) )&& {
            'landing':true,
            'details1':true
        }[this.state.page] ) {
            const solly = devis.getSolly()
            const axa = devis.getAxa()
            const fma = devis.getFma()
            const noThing = ( !( solly.hasSolly() 
                ||( showAxa &&( axa.hasAxa()|| axa.hasValidPrevAxa() ) )
                ||( showFma &&( fma.hasFma()|| fma.hasValidPrevFma() ) )
            ) )
            if ( this.state.page == 'details1' ) {
                return FrontError
            }
            if ( noThing ) {
                if (( this.state.page == 'details2' )&& axa.calculating ) return ''
                if (( this.state.page == 'details3' )&& fma.calculating ) return ''
                return FrontError
            }
        }

        if (( ! this.enableClientSubscription )&& {
            'details1':true,
            'payment':true
        }[this.state.page] ) return FrontLanding

        if (( this.preClosed )&& {
            'details1':true,
            'details2':true,
            'details3':true
        }[this.state.page] ) return FrontLanding

        if (( !this.state.axaAlive )&&( !envDev )&&( {
            'details2':true,
            'payment2':true
        }[this.state.page] )) return FrontLanding

        return {
            'landing':FrontLanding,
            'receive':FrontReceive,
            'receive2':FrontReceive,
            'details1':FrontDetails1,
            'details2':FrontDetails2,
            'details3':FrontDetails3,
            'vehicule':typeAuto ? FrontVehiculeAuto : FrontVehicule,
            'vous':FrontVous,
            'antecedents':FrontAntecedents,
            'subscribe_error':FrontSubscribeError,
            'subscribe_error2':FrontSubscribeError,
            'subscribe_error3':FrontSubscribeError,
            'presubscribe_error':FrontSubscribeError,
            'cancelled':FrontCancelled,
            'subscribing':FrontSubscribing,
            'subscribing2':FrontSubscribing,
            'subscribing3':FrontSubscribing,
            'paid_subscribed':FrontPaidSubscribed,
            'paid_subscribed2':FrontPaidSubscribed,
            'paid_subscribed3':FrontPaidSubscribedFma,
            'subscribed_solly':FrontSubscribedSolly,
            'payment':FrontPayment,
            'payment2':FrontPayment,
            'payment3':FrontPayment,
            'subscribe_solly':FrontSubscribeSolly
        }[this.state.page] || FrontLanding
    }

    render() {
        const component = this.getComponent()
        const content = component ? React.createElement(
            component, { 
                id:this.state.id,
                type:this.state.type,
                changeParams:this.changeParams.bind(this), 
                page:this.state.page,
                setPage:this.setPage.bind(this),
                devis:this.state.devis,
                topRef:this.topRef,
                axaAlive:this.state.axaAlive,
                restart:this.restart.bind(this),
                resync:this.resync.bind(this),
                embeded:this.props.embeded,
                lastBranch:this.state.lastBranch,
                checkStatus:this.checkStatus.bind(this),
                validateDevis:this.validateDevis.bind(this),
                validatePayment:this.validatePayment.bind(this),
                sendPaymentLink:this.sendPaymentLink.bind(this),
                enableClientSubscription:this.enableClientSubscription&&!this.preClosed,
                operator:this.props.operator,
                updateDevis:(devis)=>{
                    this.receiveDevis(new DataDevis(devis))
                }
            }
        ) : ''
        const waiting = ! component

        return <div className="front">
            <div className="header">
            <div className="headbox headleftaction">
                <div onClick={()=>this.setPage('vehicule')}>
                    <img src={leftarrow}/>
                    Modifier mes <br/> informations
                </div>
            </div>

            <a className="headbox"></a>

            <div className="logobox">
                <a href="https://www.assurbonplan.fr/" target="_blank"><img src={logo}/></a>
            </div>
            
            <a className="headbox"></a>
            <a className="headbox visible1600">Nos assurances</a>
            <a className="headbox visible1600">Guide et conseils</a>
            <a className="headbox visible1600">Qui sommes-nous ?</a>
            <a className="headbox visible1600">Blog</a>
            <a className="headbox visible1600">Contact</a>
            <a className="headbox visible1600">FAQ</a>
            <a className="headbox">Mon espace</a>
            <div className="headbox besoindaide">
                <span>Besoin d'aide ?</span>
                <div>
                    <img src={telephone}/>
                    <span>Contactez nos experts</span>
                    <div>09 74 77 28 61</div>
                </div>
            </div>
        </div>
        { waiting
                ? <div className="bigoverlay"><img src={waiter} className="big_waiter"/></div>
                : '' }
        <BlueHeader affiliate={this.state.affiliate} sponsor={this.state.sponsor} type={this.state.type}/>
        <div className="body">
        {( this.props.embeded && this.state.devis.in_trs )
            ?<div className="popup_payment">
                Un paiement est en cours, les données tarifantes ne pourront pas être modifiées durant la prochaine minute.
                {/*<br/><a onClick={this.ignoreTransaction.bind(this)}>▶ Ignorer le paiement en cours</a>*/}
            </div>
            :''}
            
            {content}
        </div>
        <Footer setPage={this.setPage.bind(this)}/>
        </div>
    }
}

export default Front;
